import { render } from "./gameComponent.vue?vue&type=template&id=b6ac70aa&scoped=true"
import script from "./gameComponent.vue?vue&type=script&lang=js"
export * from "./gameComponent.vue?vue&type=script&lang=js"

import "./gameComponent.vue?vue&type=style&index=0&id=b6ac70aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ac70aa"]])

export default __exports__